import React, { memo, useState } from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import { Col, Row } from "react-bootstrap";
import BrowseByCategory from "Pages/Home/Upcomingauction";
import { useLocation } from "react-router-dom";
import DigitalArtcollection from "Pages/Home/DigitalArtcollection";

export default memo( function ArtGenre(props) {
  const location = useLocation()
  const artgenrepage = location.state
  const [eventData, setEventData] = useState('Art');
  const [eventId, setEventId] = useState('63a3f8ca3afc27eac9e49068');
  const handleEventFromChild1 = (data, id) => {
    setEventData(data);
    setEventId(id);
  };
  return (
    <>
      <div className="position-relative">
        <Header />
        <div className="gradientBg">
          <div className="container-fluid profileBox communitybanner dashboardprofile">
            <Row className="mb-4">
              <Col className="text-center" lg={12}>
                <h1 className="text-center p-0">Art Genres </h1>
                {/* <p className="text-center text-white">
                  Explore The NFT's In The Most Featured Categories
                </p> */}
              </Col>
            </Row>
          </div>
        </div>
        <section className="upcoming-section browseCategory artgenreinner position-relative pb-3">


          {/* <Row>
                <Col lg={12}>
                  <Row className="justify-content-center">
                    <Col lg={7}>
                      <div className="catesearch position-relative">
                        <Input
                          className="categorySearch"
                          placeholder="Search..."
                        />
                        <button>
                          <i className="fa-light fa-magnifying-glass"></i>
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row> */}
          <Row>
            <Col className="mt-5" lg={12}>
              <BrowseByCategory handleEventFromChild1={handleEventFromChild1} data={artgenrepage} />

              <DigitalArtcollection eventData={eventData} eventId={eventId} data={artgenrepage} isArtGenre={true} />
            </Col>
          </Row>

        </section>

      </div>
      <Footer />
    </>
  );
})
